import React, { useState} from "react";
import "../../assets/Banking/LoanStatement.css";

const LoanStatement = () => {

  const data = {
    ReportDate:"22/12/2022",
    Contract:"ABC",
    ProductCode:"23123",
    BranchCode:"132",
    CusID:"CU4793",
    CusName:"Rahul",
    DueDays:"NA",
    Address:"XYZ",
    DateFrom:"12/02/2012",
    DateTo:"22/12/2022",
    InterestRate:"4%",
    AmountSanc:"Y",
    SancDate:"NA",
    MaturityDate:"12/02/2002",
    EmiAmount:"2000",
    Status:"Pending",  
    PrincipalOS:"NA",
    InterestOS:"NA",
    TotalOS:"NA",
  }

  return (
    <div>
        <div className="loan-statement">
          <div className="loan-statementlefts">
            <div className="loan-statementlogos">
            <img src="techvisionproject\src\assets\image\Screenshot 2025-09-24 111702.png" alt="Logo" />
            </div>
            <div>
              <h1 className="loan-statementtitles">Techvision</h1>
              <p className="loan-statementsubtitles">Reg. No. : U64199MH2023PLN405930</p>
              <p className="loan-statementsubtitles">
                Reg. Office & H.O.: Flat No. 2, Bldg. No. 2B, Ground Floor, Shree Gokul CHS,
                Vrindavan Society, Near Vrindavan Bus Stop, Thane (W) - 400601, Maharashtra
              </p>
            </div>
          </div></div>
          
          <div className="loan-statement-heading">
              <h2>Techvision</h2>
           <p>Loan Account Statement</p>
           <h3>Report Date : {data.ReportDate}</h3>
           <div className="loan-statement-table">
            <table>
              <thead>
                <tr>
                  <th>Contract Ref No : {data.Contract}</th>
                  <th>Product Code : {data.ProductCode}</th>
                  <th>Branch Code : {data.BranchCode}</th>
                  <th>Cus ID : {data.CusID}</th>
                  </tr><tr>
                  <th>Cus Name : {data.CusName}</th>
                  <th>Due Days : {data.DueDays}</th>
                  <th colSpan={2}>Address : {data.Address}</th>
                </tr>
              </thead>
            </table>
           </div>
           <div className="loan-statement-table">
           <table>
              <thead>
                <tr>
                  <th>Date From : {data.DataFrom}</th>
                  <th>Date To : {data.DataTo}</th>
                  <th>Interest Rate : {data.InterestRate}</th>
                  <th>Amount Sanctioned : {data.AmountSanc}</th>
                  </tr><tr>
                  <th>Sanctioned Date : {data.SancDate}</th>
                  <th>Maturity Date : {data.MaturityDate}</th>
                  <th>Emi Amount : {data.EmitAmount}</th>
                  <th>Status : {data.Status}</th>
                </tr>
              </thead>
            </table>
           </div>
            </div>

           {/* Loan Statement */}
        <section className="Loan-Statement-card-section">
          <h4>Loan Statement</h4>
          <table className="Loan-Statement-card-table">
            <thead>
              <tr>
                <th>Trans Date</th>
                <th>Particulars</th>
                <th>Debit</th>
                <th>Credit</th>
                <th>Running Balance</th>
              </tr>
               {/* <tbody className="Loan-Statement-table-body">
                {[...Array(15)].map((_,i) => (
                  <tr key={i}>
                    <td>Col {i+1} - Row 1</td>
                    <td>Col {i+1} - Row 1</td>
                    <td>Col {i+1} - Row 1</td>
                    <td>Row {i+1} - Col 2</td>
                    <td>Row {i+1} - Col 3</td>
                  </tr>
                ))}
               </tbody> */}
            </thead>
          </table>
        </section>
        
          <div className="loan-statement-table">
           <table>
              <thead>
                <tr>
                  <th>Principal OS : {data.PrincipalOS}</th>
                  <th>Interest OS : {data.InterestOS}</th>
                  <th>Total OS : {data.TotalOS}</th>
                </tr>
              </thead>
            </table>
           </div>
          
          
          </div>

  );
};

export default LoanStatement;